/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストの送信者名を更新した時の操作ログとして記録する内容
 * @export
 * @interface UpdatedMediaListSenderNameOperationLog
 */
export interface UpdatedMediaListSenderNameOperationLog {
    /**
     * メディアリストに対する操作の種類
     * @type {string}
     * @memberof UpdatedMediaListSenderNameOperationLog
     */
    actionType: string;
    /**
     * 変更前の送信者名
     * @type {string}
     * @memberof UpdatedMediaListSenderNameOperationLog
     */
    originalSenderName: string;
    /**
     * 変更後の送信者名
     * @type {string}
     * @memberof UpdatedMediaListSenderNameOperationLog
     */
    updatedSenderName: string;
}

export function UpdatedMediaListSenderNameOperationLogFromJSON(json: any): UpdatedMediaListSenderNameOperationLog {
    return UpdatedMediaListSenderNameOperationLogFromJSONTyped(json, false);
}

export function UpdatedMediaListSenderNameOperationLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedMediaListSenderNameOperationLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'originalSenderName': json['original_sender_name'],
        'updatedSenderName': json['updated_sender_name'],
    };
}

export function UpdatedMediaListSenderNameOperationLogToJSON(value?: UpdatedMediaListSenderNameOperationLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.actionType,
        'original_sender_name': value.originalSenderName,
        'updated_sender_name': value.updatedSenderName,
    };
}

